









































































import {
  apiGroupBuyingOrderGroupOrderInfo,
  ApiGroupBuyingOrderGroupOrderInfoResponse,
} from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi } from '@/hooks'
import { globalModel } from '@/model'
import { GroupBuyingUtils } from '../utils'
import { loopUntil, makeEnum, wait } from 'vtils'
import { navigateBack, navigateTo } from '@/router'
import { RequiredDeep } from 'vtils/types'
import { showSkuPicker } from '@/views/goods/exports'
import { submit } from '@/utils'
import { UserUtils } from '@/views/user/utils'

const statusEnum = makeEnum({
  拼团中: 0,
  已成团: 1,
  拼团完成: 2,
  拼团失败: 3,
  已售罄: 4,
  已下架: 5,
})

export default defineClassComponent<{
  data: RequiredDeep<ApiGroupBuyingOrderGroupOrderInfoResponse>
  simple?: boolean
}>(
  {
    props: ['data', 'simple'],
  },
  ({ props }) =>
    class {
      userLoginStatusApiData = useApi<boolean>(async () =>
        props.simple ? true : UserUtils.checkLogined(),
      )

      isLogined = computed(() => !!this.userLoginStatusApiData.data)

      isAuthor = computed(() => props.data.belongToCurrentUser)

      isJoin = computed(() => props.data.inGroup)

      isStatus = computed(() => ({
        拼团中: statusEnum.$is(props.data.groupData.groupStatus, '拼团中'),
        已成团: statusEnum.$is(props.data.groupData.groupStatus, '已成团'),
        拼团完成: statusEnum.$is(
          props.data.groupData.groupStatus,
          '拼团完成',
        ),
        拼团失败: statusEnum.$is(
          props.data.groupData.groupStatus,
          '拼团失败',
        ),
        已售罄: statusEnum.$is(props.data.groupData.groupStatus, '已售罄'),
        已下架: statusEnum.$is(props.data.groupData.groupStatus, '已下架'),
      }))

      statusInfoMap = computed<
        Record<
          number,
          {
            message: string[]
            desc?: string[]
            button?: string
            track?: Record<'name' | 'id', string>
            showBack?: boolean
            onClick?: () => any
          }
        >
      >(() => ({
        [statusEnum.拼团中]: this.isJoin.value
          ? {
              message: [
                `还差 <span>${props.data.groupData.nextLevelCount}</span> 人，赶快邀请好友一起来拼吧`,
              ],
              button: `邀请好友`,
              track: {
                name: '邀请好友',
                id: '750cebb2-fa3a-4830-9efa-6aa3ad6135d8',
              },
              onClick: () => {
                GroupBuyingUtils.share({
                  goodsName: props.data.commodityInfo.commodityName,
                  goodsPrice: props.data.commodityInfo.groupPrice,
                  goodsCover: props.data.commodityInfo.commodityImage,
                  groupOrderId: props.data.orderId,
                  remainingCount: props.data.groupData.nextLevelCount,
                })
              },
            }
          : {
              message: [
                `仅剩 <span>${props.data.groupData.nextLevelCount}</span> 个名额，赶快参与吧`,
              ],
              button: `参与${props.data.leaderUserPhone}的拼团`,
              track: {
                name: '参与拼团',
                id: '96108aab-d892-40f6-a6b4-2e4d7e07c40c',
              },
              onClick: () => {
                showSkuPicker({
                  goodsId: props.data.commodityInfo.commodityId,
                  action: 'groupBuying',
                  groupBuyingOrderId: props.data.orderId,
                })
              },
            },
        [statusEnum.已成团]: this.isJoin.value
          ? {
              message: [
                `已成团，再拼 <span>${props.data.groupData.nextLevelCount}</span> 人，单件可返 <span>￥${props.data.groupData.nextLevelReturnAmount}</span>`,
                `赶快邀请好友一起来拼吧`,
              ],
              button: `邀请好友`,
              track: {
                name: '邀请好友',
                id: '750cebb2-fa3a-4830-9efa-6aa3ad6135d8',
              },
              onClick: () => {
                GroupBuyingUtils.share({
                  goodsName: props.data.commodityInfo.commodityName,
                  goodsPrice: props.data.commodityInfo.groupPrice,
                  goodsCover: props.data.commodityInfo.commodityImage,
                  groupOrderId: props.data.orderId,
                  remainingCount: 0,
                })
              },
            }
          : {
              message: [
                `已成团，再拼 <span>${props.data.groupData.nextLevelCount}</span> 人，单件最高可返 <span>￥${props.data.groupData.nextLevelReturnAmount}</span>`,
              ],
              button: `参与${props.data.leaderUserPhone}的拼团`,
              track: {
                name: '参与拼团',
                id: '96108aab-d892-40f6-a6b4-2e4d7e07c40c',
              },
              onClick: () => {
                showSkuPicker({
                  goodsId: props.data.commodityInfo.commodityId,
                  action: 'groupBuying',
                  groupBuyingOrderId: props.data.orderId,
                })
              },
            },
        [statusEnum.拼团完成]: this.isJoin.value
          ? {
              message: [`拼团成功，我们将尽快为您发货`],
              desc: props.data.groupData.hasRefund
                ? [`差价将于7个工作日内原路返回您的账户`]
                : undefined,
              button: `查看详情`,
              track: {
                name: '查看详情',
                id: '75711bec-df5a-411d-b9d7-c2c116672c49',
              },
              onClick: () => {
                submit(async $ => {
                  $.start()
                  let mallOrderNo = props.data.mallOrderNo

                  // 兼容尚未生成中台订单的情况
                  if (!mallOrderNo) {
                    const res = await loopUntil(
                      () =>
                        apiGroupBuyingOrderGroupOrderInfo({
                          orderId: props.data.orderId,
                        }),
                      res => !!res.mallOrderNo,
                      {
                        retryDelay: 1000,
                      },
                    )
                    mallOrderNo = res.mallOrderNo!
                  }

                  // 打开订单详情
                  navigateTo(
                    props.data.commodityInfo.commodityType === 1
                      ? 'BookOrderDetail'
                      : 'OrderDetail',
                    {
                      orderNo: mallOrderNo,
                    },
                  )
                })
              },
            }
          : {
              message: [`该团已满员，看看其他团吧`],
            },
        [statusEnum.拼团失败]: this.isJoin.value
          ? {
              message: [`拼团失败，已为您退款`],
              desc: [`退款将于7个工作日内原路返回您的账户`],
              button: `查看详情`,
              track: {
                name: '查看详情',
                id: '75711bec-df5a-411d-b9d7-c2c116672c49',
              },
              showBack: true && !globalModel.state.inWechatWebView,
              onClick: () => {
                // 打开订单详情
                navigateTo('GroupBuyingOrderDetail', {
                  orderNo: props.data.userOrderId,
                })
              },
            }
          : {
              message: [`该团已过期，看看其他团吧`],
            },
        [statusEnum.已售罄]: {
          message: [`商品已售罄，看看其他好货吧`],
          button: '去看看',
          track: {
            name: '去看看',
            id: 'de9cff73-c5c2-46f4-8822-e4887aa180a5',
          },
          onClick: () => {
            // 打开商城首页
            navigateTo('HomeIndex')
          },
        },
        [statusEnum.已下架]: {
          message: [`商品已下架，看看其他好货吧`],
          button: '去看看',
          track: {
            name: '去看看',
            id: 'de9cff73-c5c2-46f4-8822-e4887aa180a5',
          },
          onClick: () => {
            // 打开商城首页
            navigateTo('HomeIndex')
          },
        },
      }))

      statusInfo = computed(
        () => this.statusInfoMap.value[props.data.groupData.groupStatus],
      )

      // 点击登录参与
      handleLoginClick = async () => {
        await UserUtils.ensureLogined()
        location.reload()
      }

      // 点击返回
      handleBackClick = () => {
        navigateBack()
      }

      // 倒计时结束刷新
      handleEnd = () => {
        submit(async $ => {
          $.start()
          await wait(2000)
          location.reload()
        })
      }
    },
)
